// extracted by mini-css-extract-plugin
module.exports = {"infoWrapper":"ClientEmergencyInfo_infoWrapper__1V4-y","itemTitle":"ClientEmergencyInfo_itemTitle__3BYiD","itemText":"ClientEmergencyInfo_itemText__3Y_AC"};